import type {ParsedStyleItem, Property} from './types'

interface GetPropertiesOptions {
    propertiesType: keyof Pick<ParsedStyleItem['parsedStyle'][0], 'properties' | 'mobileProperties'>
    prevStyle: ParsedStyleItem['parsedStyle'][0]
    currentStyle: ParsedStyleItem['parsedStyle']
    selector: string
}

const getProperties = ({
    propertiesType,
    prevStyle,
    currentStyle,
    selector
}: GetPropertiesOptions): Property[] | undefined => {
    const currentSelectorProperties = currentStyle?.[selector]?.[propertiesType]
    const prevSelectorProperties = prevStyle[propertiesType]

    if (prevSelectorProperties && currentSelectorProperties) {
        const filteredProperties = prevSelectorProperties.filter(prevProperty => {
            return !currentSelectorProperties.some(property => prevProperty.prop === property.prop)
        })

        return [...filteredProperties, ...currentSelectorProperties]
    }

    return prevSelectorProperties || currentSelectorProperties
}

const mergeStylesByBreakpoints = (styleItems: ParsedStyleItem[]): ParsedStyleItem[] => {
    let prevBreakpointStyle: ParsedStyleItem['parsedStyle'] | null = null

    styleItems.sort((a, b) =>
        b.metadata.max !== undefined && a.metadata.max !== undefined ? b.metadata.max - a.metadata.max : 0
    )

    return styleItems.map(styleItem => {
        const {parsedStyle} = styleItem

        if (prevBreakpointStyle) {
            const mergedParsedStyle = Object.entries(prevBreakpointStyle).reduce(
                (mergedStyle, [prevSelector, prevStyle]) => {
                    return {
                        ...mergedStyle,
                        [prevSelector]: {
                            ...prevStyle,
                            properties: getProperties({
                                propertiesType: 'properties',
                                prevStyle,
                                currentStyle: parsedStyle,
                                selector: prevSelector
                            }),
                            mobileProperties: getProperties({
                                propertiesType: 'mobileProperties',
                                prevStyle,
                                currentStyle: parsedStyle,
                                selector: prevSelector
                            })
                        }
                    }
                },
                {}
            )

            prevBreakpointStyle = mergedParsedStyle

            return {
                ...styleItem,
                parsedStyle: mergedParsedStyle
            }
        }

        prevBreakpointStyle = parsedStyle
        return styleItem
    })
}

export default mergeStylesByBreakpoints
